import { getLiveTagValue } from "@/features/datapoints/api/getLiveTagValue.ts"
import { getTagIntervals } from "@/features/datapoints/api/getTagIntervals.ts"
import type { DataPointIntervalRequest, TagPath } from "@/types/dataPointTypes.ts"

import { getGasDayRemaining } from "../../util/getGasDayRemaining.ts"
import { getGasDayStart } from "../../util/getGasDayStart.ts"

import type { DailyDisplayData } from "../../types/dailyDisplayTypes.ts"

export const getDailyData = async (): Promise<DailyDisplayData> => {
  const salesMeter: TagPath = {
    tag: "analog/scfm_pipeline_fe_1000",
    historyProvider: "LWRN_Historian",
    driver: "lwrn-prod-ignition:mainplc",
  }

  const salesQuality: TagPath = {
    tag: "analog/ga_1000_methane_percent",
    historyProvider: "LWRN_Historian",
    driver: "lwrn-prod-ignition:mainplc",
  }

  const flareMeter: TagPath = {
    tag: "analog/scfm_flare_fe100",
    historyProvider: "LWRN_Historian",
    driver: "lwrn-prod-ignition:mainplc",
  }

  const start = getGasDayStart("America/Chicago", 9)
  const end = new Date()
  const interval = Math.round((end.getTime() - start.getTime()) / 1000) + 1

  const averageRequest: DataPointIntervalRequest = {
    start,
    end,
    interval,
    aggMode: "Average",
  }

  const responses = await Promise.all([
    getTagIntervals(salesMeter, averageRequest),
    getTagIntervals(salesQuality, averageRequest),
    getTagIntervals(flareMeter, averageRequest),
    getLiveTagValue("LWRN_MainPLC/Analog/SCFM_PIPELINE_FE_1000"),
    getLiveTagValue("LWRN_MainPLC/Analog/GA_1000_METHANE_PERCENT"),
  ])

  const [outletSCFM, outletCH4] = [responses[3], responses[4]]

  const remainingHours = getGasDayRemaining("America/Chicago", 9)

  const gasToPipeline =
    (((responses[0][0].value || 0) * interval) / 60000) *
    ((responses[1][0].value || 0) / 100) *
    1.01

  const gasFlared = ((responses[2][0].value || 0) * interval) / 60000

  const projection =
    gasToPipeline + (remainingHours * 60 * outletSCFM * (outletCH4 / 100) * 1.01) / 1000

  return {
    gasToPipeline,
    gasFlared,
    runTime: 0,
    remainingHours,
    projection,
  }
}
